<form novalidate (ngSubmit)="submit()" [formGroup]="form">
  <ion-list>
    <ion-item>
      @if (label) {
        <ion-label position="floating">{{label | translate}}</ion-label>
      }
      @if (!label) {
        <ion-input (ionChange)="validate()" formControlName="postalCode" type="text" placeholder="{{ 'Address.PostalCode' | translate }}"></ion-input>
      }
      @if (label) {
        <ion-input (ionChange)="validate()" formControlName="postalCode" type="text"></ion-input>
      }
    </ion-item>
  </ion-list>

  <div class="ion-padding">
    <ion-button type="submit" [disabled]="!form.valid" color="primary" expand="block">
      {{ 'General.Search' | translate}}
    </ion-button>
  </div>
</form>